import React, { useState, useEffect, useCallback } from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Home from "./components/home/home";
import Login from "./components/login/login";
import Splash from "./components/splash/splash";
import Otp from "./components/otp/otp";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const [auth, setAuth] = useState({
    isLoggedIn: false,
    isOtpVerified: false,
  });

  const updateAuth = useCallback(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    const isOtpVerified = localStorage.getItem("isOtpVerified") === "true";
    setAuth({ isLoggedIn, isOtpVerified });
    console.log("Auth State Updated:", { isLoggedIn, isOtpVerified });
  }, []);

  useEffect(() => {

    updateAuth();
    
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 500); 

    const handleStorageChange = (e) => {
        if (e.key === 'isLoggedIn' || e.key === 'isOtpVerified') {
            updateAuth();
        }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [updateAuth]); 

  useEffect(() => {
    window.addEventListener('authChange', updateAuth);
    return () => {
        window.removeEventListener('authChange', updateAuth);
    };
  }, [updateAuth]);

  if (isLoading) return null;

  return (
    <Router>
      <Routes>
        {/* Default Route */}
        <Route path="/" element={<Splash />} />

        <Route
          path="/login"
          element={
            auth.isLoggedIn && auth.isOtpVerified ? (
              <Navigate to="/home" replace />
            ) : (
              <Login />
            )
          }
        />

        <Route
          path="/otp"
          element={
            auth.isLoggedIn ? (
              auth.isOtpVerified ? (
                <Navigate to="/home" replace />
              ) : (
                <Otp />
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/home"
          element={
            auth.isLoggedIn && auth.isOtpVerified ? (
              <Home />
            ) : (
              <Navigate to={auth.isLoggedIn ? "/otp" : "/login"} replace />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;